interface IProfileRouter {
  redirectTo404: void | null;
}

export type Redirect = (module: string) => void;
export type RedirectOrNull = Redirect | null;

export enum routeName {
  ROOT = 'profile',
}

export default IProfileRouter;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/router/types.ts